<template>
        <div class="is-justify-content-center has-text-centered py-6 px-6" v-if="!did_it_load()"
        style="background:#F8F9FD;">
                <p class="has-text-weight-semibold">&nbsp;
                </p>
        </div> <!-- this previous div is just empty space while the backend loads -->
        <div v-else>
                <div class="blocker" id="blocker"></div>
         <!-- but if it loaded, well, this is the actual content -->
            <div class="is-justify-content-center has-text-centered py-6 px-6" 
            style="background:#F8F9FD;" v-if="expired()"> <!-- trial period ended -->
                <p class="has-text-weight-semibold" style="font-size:1.5em">
                Tu periodo de prueba ha terminado. 
                </p>
                <br/>
                <p class="has-text-weight-semibold" style="font-size:1.5em">
                Si quieres seguir obteniendo tu reporte, paga tu Plan Basic aquí
                <a class="button is-secondary is-rounded has-text-weight-semibold"
                style="box-shadow: 4px 4px 1px 0px rgba(0, 0, 255, .2); margin-left: 0.4em;"
                 href="https://app.reveniu.com/checkout-custom-link/qxZ8ewbI6xfOKRBZ59AnWwviYcZibE5r"
                >Contratar</a>
                </p>
            </div> <!-- end trial period ended -->
            <div v-else> <!-- hasn't expired -->
                <div class="has-text-centered has-background-danger" style="color: white; font-weight: bold; font-size: 1.6em;"
                v-if="daysLeft < 31 && does_it_have_a_url_report()"> <!-- but has expiration warnings -->
                    <p v-if="daysLeft < 1">
                        Tu periodo de prueba termina en {{ hoursLeft }} hora<span v-if="hoursLeft > 1">s</span>.
                    </p>
                    <p v-else-if="daysLeft <= 31">
                        Tu periodo de prueba termina en {{ daysLeft }} dia<span v-if="daysLeft > 1">s</span>.
                    </p>
                    <p>
                        <span class="segunda-linea-pagar">
                        <a class="button is-secondary is-rounded has-text-weight-semibold pagar-button"
                        style="box-shadow: 4px 4px 1px 0px rgba(0, 0, 255, .2); margin-left: 0.3em;"
                        href="https://app.reveniu.com/checkout-custom-link/qxZ8ewbI6xfOKRBZ59AnWwviYcZibE5r"
                        >Contrata</a> Plan Basic Mensual de inmediato, o
                        <a class="button is-secondary is-rounded has-text-weight-semibold pagar-button"
                        style="box-shadow: 4px 4px 1px 0px rgba(0, 0, 255, .2); margin-left: 0.3em;"
                        :href="'https://calendly.com/lorena-cforemoto/15min?month=' + currentMonth ">
                        Contáctanos</a> si necesitas un reporte mas avanzado.</span>
                    </p>
                </div>
                <div 
                    :class="{'center-div': isDesktop}"> <!-- center -->
                        <div v-if="does_it_have_a_url_report()"> <!-- has a report -->
                            <div class="is-justify-content-center has-text-centered py-6 px-6" v-if="!has_sii()"
                            style="background:#F8F9FD;"> <!-- but something went wrong at fintoc. A warning. -->
                                    <p class="has-text-weight-semibold" style="font-size:2em">
                                        Ha ocurrido un error con su conexión a SII.
                                    </p>
                                    <p class="has-text-weight-semibold" style="font-size:2em">
                                        Por favor vuelva a registrarse en Fintoc.
                                    </p>
                                    <br/>
                                                    <SIIconnectFast
                                                        :mensajeCorto="true"
                                                        @onConnectSii="onConnectSii"
                                                    />
                            </div> <!-- end has sii div -->
                            <div class="iframecon">
                                <iframe v-if="shouldLoad" :src="url" id="iframelooker"
                                scrolling="no" frameborder="0" allowTransparency="true"
                                :style="{ 'padding-left': '5%', 'padding-right': '5%', position: 'absolute', width: '100%', height: iframeHeight, overflow: 'hidden', border: 'none' }"
                                allowfullscreen></iframe> <!-- we show the report whether fintoc is working or not -->
                            </div>
                        </div> <!-- end does it have a url report -->
                        <div v-else :class="{'center-div': isDesktop}"
                            class="has-text-centered py-6-diagram px-6-diagram" style="background:#F8F9FD;"> <!-- no report -->
                            <div class="is-justify-content-center" v-if="has_sii()"> <!-- congrats message -->
                                <i class="material-icons is-size-2 icon-clear mr-2 has-text-secondary-light">
                                    info
                                </i>
                                <p class="has-text-weight-bold is-size-4 has-text-centered mb-4">
                                ¡Felicitaciones! </p>
                                <br/>
                                <p v-if="user.client_type == 'BASIC'" class="has-text-weight-bold is-size-4 has-text-centered mb-4">
                                Tu reporte financiero está en proceso, el siguiente dia hábil
                                podrás volver a entrar con tus credenciales para verlo en línea
                                cuando quieras y desde donde quieras.
                                </p>
                                <p v-else-if="user.client_type == 'ESSENTIAL'" class="has-text-weight-bold is-size-4 has-text-centered mb-4">
                                Tu reporte financiero está en proceso.
                                Te notificaremos tan pronto como esté disponible para que puedas acceder con tus credenciales en línea,
                                en cualquier momento y desde cualquier lugar.
                                </p>
                                <p v-else-if="user.client_type == 'ENTERPRISE'" class="has-text-weight-bold is-size-4 has-text-centered mb-4">
                                Tu reporte financiero está en proceso.
                                Te notificaremos tan pronto como esté disponible para que puedas acceder con tus credenciales en línea,
                                en cualquier momento y desde cualquier lugar.
                                </p>
                            </div> <!-- end congrats message -->
                            <div class="is-justify-content-center diagram-and-button" v-else> <!-- please complete the registration process -->
                                <Diagram />
                                <br/>
                                <SIIconnectFast
                                    :mensajeCorto="true"
                                    @onConnectSii="onConnectSii"
                                />

                            </div> <!-- end please complete the registration process -->
                        </div> <!-- end no report -->
                </div> <!-- end center -->
            </div> <!-- end hasn't expired -->
        </div> <!-- end actual content -->
</template>

<script>
import { getFintocToken, saveFintocUserHolder } from "@/api/fintoc";
import { refresh } from "@/api/security";

import config from "@/config";

import SIIconnectFast from "@/components/fillData/components/SIIconnectFast";
import Diagram from "@/components/fillData/components/Diagram";

import { getSession } from "@/utils/auth";
import { mapState } from "vuex";

function getUrlOrString(input) {
  if (input == null || input.trim() === '') {
    return 'please configure the user';
  }

  if (input.startsWith('<')) {
    const match = input.match(/src="([^"]+)"/);
    return match ? match[1] : input;
  }

  return input;
}


// Start the polling when the window loads

export default {
    name: "DashboardBasic",
    components: {
        SIIconnectFast,
        Diagram,
    },
    data() {
        return {
            blockerX: 100,
            blockerY: 40,
            blockerH: 40,
            blockerW: 400,
            isDesktop: window.innerWidth > 768,
            widgetIsLoading: false,
            hasConnectSII: false,
            daysLeft: -1,
            hoursLeft: -1,
            shouldLoad: false,
            fewSecondsPassed: false,
            waitedPatiently: false,
            delayedFunctionId: -1,
            publicPath: window.location.hostname,
            diagram: Diagram,
            iframeHeight: '1000px',
            iframeHeightRaw: 1000,
            iframeSize: null,
            proportions: '',
        };
    },
    props: {
        isVisible: Boolean,
        chartLoaded: Boolean,
    },
    mounted() {
        window.addEventListener('resize', this.checkScreenSize);
        this.checkScreenSize();
        this.updateIframeHeight();
        window.addEventListener('resize', this.updateIframeHeight);
        this.waitForIframeAndAttachLoadListener();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateIframeHeight);
        window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
        setIframeSize(rect) {
            this.iframeSize = rect;
        },
        waitForIframeAndAttachLoadListener() {
            const interval = setInterval(() => {
                try {
                    const iframe = document.getElementById('iframelooker');
                    if (iframe) {
                        clearInterval(interval);
                        this.setIframeSize(this.getOffsetRect(iframe));
                        this.updateIframeHeight();
                    }
                } catch (err) {
                    console.log('Error waiting:', err);
                }
            }, 1000);
        },
        getOffsetRect(el) {
           let rect   = el.getBoundingClientRect();
            // add window scroll position to get the offset position
            let left   = rect.left   + window.scrollX;
            let top    = rect.top    + window.scrollY;
            let right  = rect.right  + window.scrollX;
            let bottom = rect.bottom + window.scrollY;
            // polyfill missing 'x' and 'y' rect properties not returned
            // from getBoundingClientRect() by older browsers
            let x = rect.x === undefined ? left : rect.x + window.scrollX;
            let y = rect.y === undefined ? top : rect.y + window.scrollY;
            // width and height are the same
            let width  = rect.width;
            let height = rect.height;
            return { left, top, right, bottom, x, y, width, height };
        },
        updateIframeHeight() {
            // to make it not scroll, we will force it to keep the 1366x768 proportions
            // the issue is that if the iframe subwindow becomes smaller than
            // the display, it will scroll
            const width = window.innerWidth;
            const height = window.innerHeight;
            this.proportions = width + ' x ' + height
            this.iframeHeightRaw = ((width*0.9) * 768.0 / 1366.0);
            this.iframeHeight =  this.iframeHeightRaw + 'px';
            if (this.iframeSize != null) {
                const iframe = document.getElementById('iframelooker');
                var padding = 0;
                if (iframe) {
                    padding = iframe.style.paddingRight;
                }
                const blocker = document.getElementById('blocker');
                blocker.style.position = 'absolute';
                if (width < 200) {//empirical af
                    blocker.innerHTML = '________';
                } else if (width < 200) {
                    blocker.innerHTML = '____________';
                } else if (width < 400) {
                    blocker.innerHTML = '____________________';
                } else if (width < 600) {
                    blocker.innerHTML = '______________________________';
                } else if (width < 800) {
                    blocker.innerHTML = '____________________________________________________________';
                } else {
                    blocker.innerHTML = '________________________________________________________________________________';
                }
                this.blockerX = padding; //this is a percentage
                blocker.style.right = this.blockerX;
                this.blockerY = this.iframeHeightRaw + this.iframeSize.top - 25; //empirical, this is in pixels
                blocker.style.top = this.blockerY + 'px'
                blocker.style.zIndex = 100;
                blocker.style.backgroundColor = '#2e2f47'; //not 100% sure this is the color
                blocker.style.color = '#2e2f47';
            }
        },
        did_it_load() {
            if (this.user.user_info_loaded) {
                if (this.user.client_type != 'BASIC') {
                    this.daysLeft = 99999999;
                    this.hoursLeft = 99999999;
                } else {
                    let trialPeriodEnd = this.user.expiration_date;
                    if (trialPeriodEnd) {
                        let trialPeriodEndDate = new Date(trialPeriodEnd);
                        let now = new Date();
                        let periodmili = trialPeriodEndDate.getTime() - now.getTime();
                        let periodDays = periodmili / 1000 / 60 / 60 / 24;
                        let periodHours = periodmili / 1000 / 60 / 60;
                        if (periodDays > 0) {
                            this.daysLeft = parseInt(periodDays);
                        } else {
                            this.hoursLeft = parseInt(periodHours);
                            this.daysLeft = -1;
                        }
                    } else {
                        this.daysLeft = 9999999999;
                    }
                }
            }
            return Boolean(this.user.user_info_loaded);
        },
        does_it_have_a_url_report() {
            return Boolean(this.user.url_report != null && this.user.url_report.trim() != '');
        },
        has_sii() {
                return Boolean((this.user.account_link &&
                this.user.account_link.status &&
                this.user.account_link.status == 'OK' &&
                this.user.account_link.link_token_valid == true) ||
                (this.user.no_sii_message == true));
        },
        checkScreenSize() {
            this.isDesktop = window.innerWidth > 768;
        },
        onConnectSii() {
            const product_type = "invoices";
            this.widgetIsLoading = true;
            getFintocToken({ product_type: product_type })
                .then((response) => {
                    this.widget = window.Fintoc.create({
                        holderType: "business",
                        product: product_type,
                        publicKey: response.data.public_key,
                        webhookUrl: `${config.webhookAPI}/fintoc_app/link_token/?token=${response.data.webhook_token}`,
                        onExit: () => this.onWidgetExit(),
                        onSuccess: (link) =>
                            this.onWidgetSuccess(
                                response.data["company_product_link"]["id"],
                                link
                            ),
                    });
                    this.widget.open();
                    this.widgetIsLoading = false;
                })
                .catch(() => {});
        },
        async onWidgetSuccess(id, linkp) {
            linkp["company_product_link_id"] = id;
            await saveFintocUserHolder(linkp);
            const session = getSession();
            await refresh(session.token);
            this.hasConnectSII = true;
        },
        onWidgetExit() {
            this.widget.destroy();
        },
        expired() {
            let daysLeft = this.daysLeft;
            return daysLeft < 0;
        },
    },
    computed: {
        ...mapState("userAuth", ["user", "hasSIIAutomation"]),
        url: {
            get: function() {
                return getUrlOrString(this.user.url_report);
            },
        },
        currentMonth() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1; 
            const formattedMonth = month.toString().padStart(2, '0');
            return `${year}-${formattedMonth}`;
        },
    },
    watch: {
/* ugh, maquina de estado del infierno
 * básicamente, miramos el booleano isVisible, que controla si esta pestaña se muestra (en Dashboard.vue)
 * if:
 * estamos mostrando la pestaña Y el gráfico en el conciliador terminó de cargar, permitimos que se cargue el iframe.
 * (ten en cuenta que las pestañas del Encabezado deberían asegurarse de que la pestaña del informe no sea clickeable
 * si el gráfico en el informe no conciliador, es decir, si chartLoaded es falso)
 * ENTONCES, si el usuario NO ha esperado pacientemente, el componente esperará 5 segundos; si esta espera termina,
 * "waitPatiently" ahora es verdadero para siempre, y el gráfico de looker studio no se recargará.
 * esto significa que waitPatiently solo se vuelve verdadero UNA VEZ
 *
 * else if:
 * en caso contrario, si este componente está oculto, entonces verificamos si el usuario ha esperado pacientemente al menos una vez:
 * Si el usuario ha esperado pacientemente al menos una vez, significa que shouldLoad no deberia cambiar.
 * de otra forma, llega al clearTimeout, lo que significa que el usuario hizo clic en otra pestaña y deberíamos cancelar la espera.
 * Eso marca al usuario como que ha esperado pacientemente; luego "shouldLoad" se marca como falso, lo que descarga el iframe.
 * El usuario debera volver a empezar a cargar la pagina y esperar pacientemente.
 * 
 * Este if deberia poder manejar el caso de tres o mas tabs, pero seria bueno probarlo.
 */
        isVisible(newValue) {
            if (newValue && this.chartLoaded) {
                this.shouldLoad = true;
                if (!this.waitedPatiently) {
                    this.delayedFunctionId = setTimeout(() => {this.waitedPatiently = true;}, 5000);
                }
            } else if (!newValue && !this.waitedPatiently) {
                clearTimeout(this.delayedFunctionId);
                this.shouldLoad = false;
            }
        },
    }
};
</script>

<style scoped>
.center-div {
    width: 100%;
    height: 90%;
    margin: auto;
}

@media screen and (max-width: 768px) {
  .center-div {
    display: block; /* or whatever your mobile styling is */
  }
}
.segunda-linea-pagar {
    font-size: 80%;
}
.pagar-button {
    position: relative;
    bottom: 3px;
}
.py-6-diagram {
    padding-top: 2em;
}
.px-6-diagram {
    padding-left: 0;
    padding-right: 0;
}
</style>
